export const exclude = <T, U extends keyof T>(
  obj: T,
  keys: U[],
): Omit<T, keyof U> => {
  const result = { ...obj };
  keys.forEach((key) => {
    delete result[key];
  });
  return result;
};
